import * as React from "react";

import { UitkLayoutGrid } from "uitk-react-layout-grid";

import HotelCard from "./HotelCard";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { HotelsFlexModuleResult } from "typings/microserviceModels/hotels-flex-module";

const ListLayout = (props: { context: ExtendedContextStore; model: HotelsFlexModuleResult }) => {
  const { context, model } = props;
  const { hotels } = model;

  const keyHelper = new ItemKeyHelper("hotels");

  return (
    <UitkLayoutGrid columns={1} space="three" className="all-t-margin-three">
      {hotels.map((hotel) => (
        <HotelCard key={keyHelper.next()} context={context} model={model} hotel={hotel} />
      ))}
    </UitkLayoutGrid>
  );
};

export default ListLayout;
